import React, { useRef, useState } from 'react';
import styled from '@emotion/styled';

import { Field, Input, Textarea } from '../lumen';
import { editProject as apiEditProject } from '../utils/ApiUtilsV5';
import { ActionModal } from './ActionModal';

export const RenameProjectModal = ({ project, onClose, onSaved }) => {
  const originalRef = useRef({
    name: project.name || '',
    description: project.description || ''
  });
  const { name: originalName, description: originalDescription } = originalRef.current;

  const [name, setName] = useState(originalName);
  const [description, setDescription] = useState(originalDescription);

  const trimmedName = name.trim();
  const trimmedDescription = description.trim();

  const hasChanges =
    trimmedName !== originalName ||
    trimmedDescription !== originalDescription;

  const handleSubmit = () => {
    // No-op save: just close, don't hit the API.
    if (!hasChanges) {
      onClose();
      return;
    }
    return apiEditProject(project.project_id, {
      name: trimmedName,
      description: trimmedDescription
    }).then(() => {
      onSaved?.({ name: trimmedName, description: trimmedDescription });
      onClose();
    });
  };

  return (
    <ActionModal
      title="Rename project"
      submitLabel="Save"
      submittingLabel="Saving…"
      fallbackErrorMessage="Can't update the project"
      disabled={!trimmedName}
      onSubmit={handleSubmit}
      onClose={onClose}
    >
      <FormGrid>
        <Field label="Name" htmlFor="rename-project-name">
          <Input
            id="rename-project-name"
            aria-label="Project name"
            value={name}
            autoFocus
            onChange={event => setName(event.target.value)}
          />
        </Field>
        <Field label="Description" htmlFor="rename-project-description">
          <Textarea
            id="rename-project-description"
            aria-label="Project description"
            value={description}
            onChange={event => setDescription(event.target.value)}
          />
        </Field>
      </FormGrid>
    </ActionModal>
  );
};

const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
